

import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";


function DissolutionOfDeeds() {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",

      }));
    }
  }, []);


  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };


  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_category: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);

  const service = services.find(s => s.service_id === 36);

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    // Email validation
    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // Phone number validation
    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //    newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_contact.trim()) {
      newErrors.user_contact = 'number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // Category validation


    // City validation
    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };



  // const formPutPartenshipdeed = async (e) => {
  //   e.preventDefault();
  //   // ✅ Check if user is logged in
  //   // if (!token) {
  //   //   alert("Please log in to continue.");
  //   //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
  //   //   navigate('/login'); // 👈 Use this if you're using React Router
  //   //   return;
  //   // }
  //   if (!validateForm()) return;

  //     localStorage.setItem("bookingData", JSON.stringify(newData));

  //     // Navigate to checkout
  //     navigate('/checkout', {
  //        state: {
  //           service: service,

  //        }
  //     });
  // };

  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
        const response = await PartenerSheepDeedService.Dissolution(newData);

        console.log("API Success:", response);

        navigate("/thankyou");

        // Optional: reset form
        setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    

    } catch (error) {
        console.error("API Error:", error);
        alert("Something went wrong!");
    }
};


  const faqs = [
    {
      question: "How can a Partnership Firm be dissolved?",
      answer: "By Mutual Consent, By Notice, By Court Order, Compulsory Dissolution, and Due to Contingencies."
    },
    {
      question: "What is Dissolution by Court?",
      answer: "When partners can't continue, the court may dissolve the firm due to reasons like mental instability, misconduct, or transfer of interest."
    },
    {
      question: "Who is liable after dissolution?",
      answer: "All partners remain liable except those who are insolvent or deceased."
    },
    {
      question: "What is Compulsory Dissolution?",
      answer: "Occurs when all or most partners are insolvent or when the firm engages in illegal activities."
    },
    {
      question: "What does Section 39 state?",
      answer: "It defines dissolution as the ending of the partnership among all partners."
    },
    {
      question: "Which section allows court dissolution?",
      answer: "Section 44 outlines the grounds under which a court may dissolve a partnership firm."
    },
    {
      question: "What’s the difference between dissolution of partnership and firm?",
      answer: "A partnership may continue with changes in partners, but dissolution of a firm means complete business closure."
    },
    {
      question: "Is mutual consent enough to dissolve a firm?",
      answer: "Yes, it is the simplest and most common method of dissolution."
    },
    {
      question: "Does a partner’s retirement cause dissolution?",
      answer: "No, the remaining partners can continue the firm."
    },
    {
      question: "Does a partner’s death dissolve the firm?",
      answer: "Yes, unless a new partnership deed is created by the remaining partners."
    }
  ];

const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};


  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>
                <h1 className="sk-text-color">Dissolution of Partnership Firm</h1>
                <p className="pdrl-text">Get Dissolution of Partnership Firm for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                <p className="pd-text">Under the Indian Partnership Act, 1932, a partnership can be formally ended through a Deed of Dissolution. Let DM2Legal take care of this legal process for you, ensuring a smooth and hassle-free closure.</p>
                <p className="pd-text">Starting a partnership is one of the easiest ways to begin a business with someone. However, circumstances may arise where ending the partnership becomes necessary. This process is known as the Dissolution of Partnership, and it requires the creation of a formal Deed of Dissolution to make it legally valid.</p>

                {/*                <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div> */}
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now </h3>
                  <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label> {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>

                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <p className="pd-text">A Dissolution Deed, also known as a Deed of Dissolution of Partnership, is a legal document created when partners of a firm decide to formally end their partnership. This process is governed by Section 39 of the Indian Partnership Act, 1932.
              </p>
              <p className="pd-text">The dissolution of a firm signifies the complete termination of the partnership between all its partners. It involves settling accounts, dividing assets, and clearing liabilities. While it may seem straightforward, dissolving a partnership comes with legal complexities and financial risks that must be managed with expertise.
              </p>
              <p className="pd-text">Unsure where to start? Let DM2Legal guide you through the process. Our professionals specialize in handling all matters related to partnership dissolution—ensuring a smooth and compliant transition.
              </p>
            </div>
          </div>
          <div className="space20"></div>

        </div>
      </div>



      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">What is Partnership Firm Dissolution?</h2>
                <div className="space20"></div>
                <p className="pd-text">A partnership is a distinctive business arrangement where two or more individuals join forces to pursue a common business goal, sharing profits and losses in a predetermined ratio. Like any other business entity, partnerships may encounter difficulties that result in the need to dissolve the firm. This process is typically outlined in the partnership agreement and follows a formal procedure.</p>
                <div className="space20"></div>
                <p className="pd-text">Dissolution of a partnership signifies the formal termination of the partnership business, effectively ending the relationship among partners. This can occur voluntarily—by mutual decision—or compulsorily, such as when the firm engages in illegal activities.</p>
                <div className="space20"></div>
                <p className="pd-text">
                  The dissolution process involves winding up business operations, settling debts, liabilities, and claims among partners, and finally distributing the remaining assets. These actions are carried out as per the terms set forth in the original partnership agreement, or through a newly executed dissolution deed specifying the procedure and conditions.
                </p>  <div className="space20"></div>
                <p className="pd-text">
                  Common Reasons for Dissolution of a Partnership Firm:</p>


              </div>
            </div>

            <div className="col-lg-8">
              <div className="hadding7">
                <div className="space20"></div>

                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Mutual agreement among partners
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Fulfillment of the business objective or project
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                      Death of a partner
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Bankruptcy, insolvency, or retirement of a partner
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                      Violation of partnership agreement terms
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Expiry of the partnership duration
                    </li>


                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
            </div>
          </div>
          <div className="space40"></div>

          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">

                <h2 className="text-center">
                  What are the different ways of Dissolution of a Partnership Firm?  </h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="space20"></div>
              <p className="pd-text">Dissolving a partnership can occur through various means, depending on the specific circumstances surrounding the decision. It may happen through mutual consent, legal compulsion, or unforeseen situations that make continuing the partnership unviable. The process and method of dissolution are determined by the nature and context of the partnership.
              </p>
              <div className="space20"></div>
              <p className="pd-text">A partnership can be dissolved in several ways, depending on the circumstances. Most commonly, partners may mutually agree to end the partnership through voluntary consent. Dissolution may also occur automatically upon the happening of certain events outlined in the partnership agreement. In some cases, if continuing the business becomes illegal or impractical, dissolution is required. Additionally, any partner has the right to initiate dissolution by providing written notice to the others. Lastly, a competent court may order dissolution in situations involving misconduct, breach of agreement, or other justifiable reasons.</p>
              <div className="space20"></div>
              <p className="pd-text">Following dissolution, the firm must undergo a winding-up process, which involves settling debts, liquidating assets, and distributing the remaining proceeds among the partners. Additionally, necessary legal formalities must be completed in accordance with the provisions of the Partnership Act, and all relevant tax obligations must be fulfilled.</p>
            </div>

          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">
                  Clause to Dissolve a Partnership in Partnership Deed
                </h2>
                <div className="space20"></div>
                <p className="pd-text">Before starting a partnership, it’s standard practice to establish a written agreement that outlines the terms and conditions governing the relationship between partners. One key component of this agreement is the dissolution clause, which provides clarity on how the partnership may be brought to an end.
                </p>
                <div className="space20"></div>
                <p className="pd-text">This clause sets forth the scenarios under which the partnership may be dissolved, helping all partners understand their rights and responsibilities in such situations. The structure and content of the dissolution clause can vary depending on the type of partnership, the legal framework, and the specific preferences of the partners involved.
                </p>
                <div className="space20"></div>

                <p className="pd-text">
                  When drafting a dissolution clause, the following key aspects should be considered:</p>


              </div>
            </div>

            <div className="col-lg-8">
              <div className="hadding7">
                <div className="space20"></div>

                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Defined triggers for dissolution – Clearly outline specific events or circumstances that may lead to the partnership being dissolved.
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Notice by partners – Allow for any partner to provide written notice to the others if they wish to initiate the dissolution process.
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Completion-based dissolution – If the partnership was formed for a particular project or purpose, define that its completion will lead to dissolution.
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Winding-up procedures – Detail the steps involved in closing the business operations, including asset distribution and liability settlements.
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                      Final accounts – Clarify how the financial accounts will be settled among partners at the time of dissolution.
                    </li>

                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
            </div>
          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">

                <h2 className="text-center">

                  Decoding Section 39 of the Indian Partnership Act:
                </h2>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="space20"></div>
              <p className="pd-text">The Indian Partnership Act, 1932 lays down the legal framework for the establishment and dissolution of partnerships in India. Among its provisions, Section 39 specifically addresses the dissolution of a firm, which occurs when the partnership between all partners of a firm comes to an end.
              </p>
              <div className="space20"></div>
              <p className="pd-text">Section 39 serves as the foundation for the clauses that follow in the Act. It outlines the various legal modes of dissolution — including dissolution by mutual agreement, compulsory dissolution, dissolution upon the occurrence of specific events, dissolution by notice, and dissolution through court intervention. While it introduces these scenarios, the detailed procedures such as asset distribution and liability settlement are discussed in later sections of the Act.
              </p>
              <div className="space20"></div>
              <p className="pd-text">
                This section is applicable to registered partnerships across India. In the case of unregistered partnerships, dissolution is usually guided by common law principles and the terms of the partnership agreement.
              </p>
              <div className="space20"></div>
              <p className="pd-text"> A clear understanding of Section 39 is crucial for ensuring that the dissolution of a partnership is handled lawfully and smoothly. If you require expert assistance with this process, you can easily consult professionals from the comfort of your home through the DM2Legal platform.
              </p>
            </div>



          </div>
          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">

                  Aspects of Premature Dissolution of Partnership Firm

                </h2>
                <div className="space20"></div>
                <p className="pd-text">When a partnership firm is dissolved before the term specified in the partnership deed, it is referred to as premature dissolution. Such a situation may arise due to internal conflicts, financial instability, or unexpected events.</p>

                <div className="space20"></div>

                <p className="pd-text">
                  At DM2Legal, we help you understand the complexities involved in this process. Some of the key considerations include:</p>


              </div>
            </div>

            <div className="row">
              <div className="col-lg-4">
                <div className="hadding7">
                  <div className="space20"></div>

                  <div className="contact6-list">
                    <ul>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Dissolution Procedure
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                        Winding-Up Activities
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                        Handling Financial Obligations                    </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Tax Considerations
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Partner Rights & Duties
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="hadding7">
                  <div className="space20"></div>

                  <div className="contact6-list">
                    <ul>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Goodwill and Brand Value
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                        Emotional and Interpersonal Factors
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>

                        Missed Business Prospects                   </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Effect on Staff and Collaborators
                      </li>
                      <li className="font-f-7">
                        <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                        Importance of Professional Guidance
                      </li>

                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <img src="assets/img/images/Documents-Required-for-IEC-Registration.png" alt="" />
              </div>
            </div>
          </div>

          <div className="space20"></div>
        </div>
      </div>








      <div className="space40 bg-white"></div>
      <div className="bg-white">

        <div className="container ">

          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FAQs on Import Export License </h2>
                    <div className="space20"></div>


                    <div id="general">



                      {faqs.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}







                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Testimonials />



      <div className="sp2 last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Hassle-Free Dissolution</a></h4>
                  <p>At DM2Legal, users can easily register by simply providing their name, email ID, contact number, and the required service details. Once registered on our platform, our team will promptly get in touch with you to guide you through the partnership dissolution process.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Leading Online Platform</a></h4>
                  <p>DM2Legal boasts one of the largest client networks, making us one of India’s top online platforms for partnership dissolution services under the Partnership Act. No matter where you are located, we are fully equipped to assist you online.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Outstanding Support</a></h4>
                  <p>Our DM2Legal team is renowned for providing thorough support and assistance to all clients. We remain available even after your service is completed and welcome your feedback to help us continually improve.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Complete your partnership dissolution with a team that has over 10 years of industry experience. Choosing DM2Legal means working with seasoned professionals across India who ensure a smooth and efficient process.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Affordable Services</a></h4>
                  <p>DM2Legal offers cost-effective solutions without compromising on quality. We prioritize your satisfaction and budget with every service we provide, ensuring excellent value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Timely Delivery</a></h4>
                  <p>We understand the importance of your time. Our team is committed to delivering services promptly, ensuring no unnecessary delays throughout your partnership dissolution.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>


      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default DissolutionOfDeeds;